<script setup lang="ts">
import type { ButtonProps } from '#layers/ui/components/Button.vue';
import { computed, useAttrs } from 'vue';
import { useAppConfig } from '#app/config';
import DButton from '#layers/ui/components/Button.vue';
import DTooltip from '#layers/ui/components/Tooltip.vue';
import { useDisabledNotice } from '#layers/ui/composables/use-disabled-notice';

defineOptions({
	name: 'ButtonAdd',
	inheritAttrs: false,
});

const {
	size = 'sm',
	variant = 'outline',
	color = 'neutral',
	// eslint-disable-next-line unicorn/no-useless-undefined -- an absent Boolean prop without a default becomes `false`, and NuxtLink rejects `prefetch` and `noPrefetch` both being false
	prefetch = undefined,
	// eslint-disable-next-line unicorn/no-useless-undefined -- an absent Boolean prop without a default becomes `false`, and NuxtLink rejects `prefetch` and `noPrefetch` both being false
	noPrefetch = undefined,
	disabled,
	disabledNotice,
	...forwardedProps
} = defineProps<Partial<ButtonProps & { disabled?: boolean; disabledNotice?: string }>>();

const attrs = useAttrs();
const { showDisabledNotice } = useDisabledNotice({ disabled: () => disabled, disabledNotice: () => disabledNotice });
const buttonProps = computed(() => ({ ...attrs, ...forwardedProps, size, variant, color, prefetch, noPrefetch, disabled }));
const appConfig = useAppConfig();
</script>

<template>
	<DTooltip :delay-duration="0" :disabled="!showDisabledNotice" :text="disabledNotice">
		<DButton
			v-bind="buttonProps"
			:icon="appConfig.ui.icons.plus"
		>
			<slot />
		</DButton>
	</DTooltip>
</template>
